import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import styles from './ResolutionStyles'

export default ({
  onClick, currentResolution, className, ariaLabelResolution
}) => {
    if (isNaN(currentResolution)) return null
    return (
      <div className={styles.component} aria-label={ariaLabelResolution}>
        <Dropdown
          className={styles.button}
          upward text={currentResolution === 0 ? '720p' : '360p'}>
            <Dropdown.Menu>
              <Dropdown.Item text='720p' onClick={onClick(0)} />
              <Dropdown.Item text='360p' onClick={onClick(1)} />
            </Dropdown.Menu>
        </Dropdown>
      </div>
    )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Resolution/Resolution.js